import { Box, Button, CircularProgress } from "@mui/material";
import { memo, useEffect } from "react";
import { useAlert } from "react-alert";
import { useNavigate } from "react-router-dom";
import { useUpdateTaskMutation } from "../../../redux/Task/TaskApi";
import { userAccess } from "../../../utils/CommonFunction";
const BTN_STYLE = {
  minWidth: 150,
  textTransform: "none",
  borderRadius: "10px",
  boxShadow: "none",
};

const isValidUrl = (urlString) => {
  var urlPattern = new RegExp(
    "^(https?:\\/\\/)?" + // validate protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // validate domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // validate OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // validate port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // validate query string
      "(\\#[-a-z\\d_]*)?$",
    "i",
  ); // validate fragment locator
  return !!urlPattern.test(urlString);
};

const TaskButton = ({ task, action }) => {
  const navigate = useNavigate();
  const [
    updateTaskApiCall,
    {
      isLoading: updateTaskLoading,
      isError: updateTaskError,
      isSuccess: updateTaskSuccess,
    },
  ] = useUpdateTaskMutation();
  const alert = useAlert();

  const updateTaskApi = async () => {
    const request = {
      ...task,
    };
    request.completedAction = action.id;
    request.completedBy = userAccess().userId;
    request.completedByName =
      userAccess().firstName + " " + userAccess().lastName;

    updateTaskApiCall(request);
  };
  useEffect(() => {
    if (updateTaskError) {
      alert.error("Error while completing task");
    }
  }, [alert, updateTaskError]);

  useEffect(() => {
    if (updateTaskSuccess) {
      alert.success("Successfully completed task");
    }
  }, [alert, updateTaskSuccess]);

  return (
    <Box>
      <Button
        variant={action.type === "link" ? "contained" : "outlined"}
        size="small"
        disabled={updateTaskLoading}
        sx={[BTN_STYLE]}
        onClick={(e) => {
          e.stopPropagation();
          if (action.type === "link" && isValidUrl(action.url))
            window.open(action.url, action.newTab ? "_blank" : "_self");
          else if (action.type === "link") navigate(action.url);
          else updateTaskApi();
        }}
      >
        {updateTaskLoading ? (
          <CircularProgress color="inherit" size={20}></CircularProgress>
        ) : (
          action.text
        )}
      </Button>
    </Box>
  );
};

export default memo(TaskButton);
